import { render } from "./ResourcesAppliedFilters.vue?vue&type=template&id=523f691e&scoped=true"
import script from "./ResourcesAppliedFilters.vue?vue&type=script&lang=js"
export * from "./ResourcesAppliedFilters.vue?vue&type=script&lang=js"

import "./ResourcesAppliedFilters.vue?vue&type=style&index=0&id=523f691e&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523f691e"]])

export default __exports__